import { inject, Injectable } from '@angular/core';
import { catchError, shareReplay, switchMap, take, throwError } from 'rxjs';
import { ApiService } from '../api/api.service';
import { AuthenticatorService } from '../authenticator.service';
import { Profile, ProfileError } from './account.model';
import { IdSystemUserService } from '../id-system';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  private api = inject(ApiService)
  private authenticator = inject(AuthenticatorService)
  private idSystemUser = inject(IdSystemUserService)

  readonly account$ = this.authenticator.auth$.pipe(
    switchMap(isAuthed => isAuthed ? this.idSystemUser.getAccountDetail() : throwError(() => new ProfileError('Not authenticated'))),
    catchError((error: unknown) => throwError(() => new ProfileError(error instanceof Error ? error.message : 'Unknown error'))),
    shareReplay({ bufferSize: 1, refCount: false })
  )

  readonly profile$ = this.authenticator.auth$.pipe(
    switchMap(isAuthed => isAuthed ? this.api.get<Profile>('/account/get-profile') : throwError(() => new ProfileError('Not authenticated'))),
    catchError((error: unknown) => throwError(() => new ProfileError(error instanceof Error ? error.message : 'Unknown error'))),
    shareReplay({ bufferSize: 1, refCount: false })
  )

  getAccount() {
    return this.authenticator.isAuthed ? this.account$.pipe(take(1)) : throwError(() => new ProfileError('Not authenticated'))
  }

  getProfile() {
    return this.authenticator.isAuthed ? this.profile$.pipe(take(1)) : throwError(() => new ProfileError('Not authenticated'))
  }
}
